import type { SVGProps } from "react";

import { forwardRef } from "react";

export const LogoFavicon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    ref={ref}
    fill="none"
    height="1em"
    viewBox="0 0 203 203"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M153.557.166H49.053C21.962.166 0 22.128 0 49.219v104.504c0 27.091 21.962 49.053 49.053 49.053h104.504c27.091 0 49.053-21.962 49.053-49.053V49.219c0-27.091-21.962-49.053-49.053-49.053z"
      fill="#0152F8"
    />
    <path
      d="M152.459 55.322v2.385l-39.624 43.759 39.624 43.76v2.384h-20.37l-34.535-37.553H76.87v37.553H59.68V55.322h17.19v37.553h20.684l34.535-37.553h20.37z"
      fill="#FAFAFA"
    />
  </svg>
));

LogoFavicon.displayName = "LogoFavicon";

export default LogoFavicon;
